import { Button, Form } from "react-bootstrap";
import SideModal from "../UI/SideModal/SideModal";
import { useState } from "react";
import { AdminService } from "../../services/admin.service";
import toast from "react-hot-toast";

interface IAddCategoryModal {
    show: any
    handleClose: any
}

export default function AddCategoryModal(props: IAddCategoryModal) {
    const [data, setData] = useState<any>()

    const addExamCategory = async () => {
        await AdminService.addExamCategory(data).then((res) => {
            if (res.status === 200) {
                props.handleClose()
            }
        }).catch((err) => {
            toast.error(err.response.data)
        })
    }

    return (
        <>
            <SideModal
                show={props.show}
                handleClose={props.handleClose}
                title="Add Exam Category"
                body={
                    <>
                        <Form.Group className="mb-3">
                            <Form.Label className="ds-label">Name</Form.Label>
                            <Form.Control placeholder="Enter category name" onChange={(e: any) => setData({ ...data, name: e.target.value })} />
                        </Form.Group>
                        <div className="ds-field-row">
                            <div>
                                <span className="ds-label" style={{ marginBottom: 0 }}>Allowed</span>
                                <span className="ds-help-text">Enable this exam category</span>
                            </div>
                            <Form.Switch onChange={(e: any) => setData({ ...data, allowed: e.target.checked })} />
                        </div>
                    </>
                }
                footer={
                    <div className="ds-drawer-actions">
                        <button className="ds-btn ds-btn-secondary" onClick={props.handleClose}>
                            Cancel
                        </button>
                        <button className="ds-btn ds-btn-primary" onClick={addExamCategory}>
                            Create
                        </button>
                    </div>
                }
            />
        </>
    )
}